import React from 'react';

const Toggler = ({
  title,
  checked,
  defaultChecked,
  setFieldValue,
  name,
}: any) => {
  return (
    <div className="flex items-center justify-between">
      <h4>{title}</h4>
      <label
        htmlFor={name}
        className="toggle inline-block w-12 h-6 bg-gray-100 rounded-full border-2 border-light-gray relative cursor-pointer"
      >
        <div
          className={`absolute w-6 h-6 rounded-[50%] -top-[2px] -left-[2px] bg-light-gray transition-transform duration-650 ${
            checked ? 'transform translate-x-full bg-primary' : ''
          }`}
        ></div>
        <input
          type="checkbox"
          id={name}
          name={name}
          className="hidden"
          defaultChecked={defaultChecked}
          onChange={() => {
            setFieldValue(name, !checked);
          }}
        />
      </label>
    </div>
  );
};

export default Toggler;
